import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../helper/useAuth";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { CampaignCountryCostApiResponse } from "../../features/Apps/interface";

interface CampaignCountryCostParams {
  appPackageId: string;
  countryCode: string;
  startDate: Date;
  endDate: Date;
}

export const useCampaignCountryCost = (params: CampaignCountryCostParams) => {
  const { selectedIntegration } = useAuth();
  const { appPackageId, countryCode, startDate, endDate } = params;

  const from_date = startDate.toISOString().split("T")[0];
  const to_date = endDate.toISOString().split("T")[0];

  return useQuery({
    queryKey: [
      "campaignCountryCost",
      selectedIntegration?.value,
      appPackageId,
      countryCode,
      from_date,
      to_date,
    ],
    queryFn: async () => {
      const response = await httpService.get<CampaignCountryCostApiResponse>(
        API_CONFIG.path.getCampaignCountryCost,
        {
          app_package_id: appPackageId,
          country_code: countryCode,
          from_date,
          to_date,
          tracking_id: selectedIntegration?.value as string,
        }
      );
      return response;
    },
    // Only fetch if we have all required parameters
    enabled: !!selectedIntegration?.value && !!appPackageId && !!countryCode,
  });
};
